import React from 'react';
import { FileTextIcon } from 'lucide-react';
export const TermsNotes = () => {
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-238">
      <div className="p-6" data-id="element-239">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-240">Vilkår & noter</h2>
        <div className="prose prose-sm max-w-none text-gray-600" data-id="element-241">
          <p data-id="element-242">
            Dimensionering er foretaget i henhold til DS 452 og DS 469. Alle
            materialer og komponenter overholder gældende standarder og er
            CE-mærkede. Der tages forbehold for ændringer i
            produktspecifikationer, leveringstider og priser. Ved accept af
            tilbud bekræfter kunden at have læst og forstået de tekniske
            specifikationer og vilkår.
          </p>
          <p data-id="element-243">
            Ved restordre eller leveringsproblemer forbeholder Roth sig retten
            til at levere tilsvarende produkter af samme eller bedre kvalitet.
            Alle priser er ekskl. montage medmindre andet er angivet.
          </p>
        </div>
        <div className="mt-4" data-id="element-244">
          <button className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-245">
            <FileTextIcon className="mr-2 h-4 w-4" data-id="element-246" />
            Datablade & DoP
          </button>
        </div>
      </div>
    </section>;
};